module.exports = __webpack_public_path__ + "img/H3.96e024d6.png";